import { useState } from 'react';

import { api } from 'fr-shared/api';

const getCommercialInvoice = (
  { shipped_date, tracking_number, line_items },
  { lineItemDetails, importer, additionalInformation }
) => {
  const lineItems = line_items.map(li => ({
    id: li.order_line_item_id,
    quantity: li.quantity,
    description: lineItemDetails[li.order_line_item_id]?.description,
    hs_code: lineItemDetails[li.order_line_item_id]?.hs_code,
  }));

  return api.post('/commercial_invoice', {
    commercial_invoice: {
      ship_date: shipped_date,
      tracking_number,
      line_items: lineItems,
      importer,
      additional_information: additionalInformation,
    },
  });
};

const useCommercialInvoice = shipmentValues => {
  const [loadingCommercialInvoice, setLoadingCommercialInvoice] = useState(false);
  const [commercialInvoice, setCommercialInvoice] = useState(null);

  const handleGenerateCommercialInvoice = details => {
    setLoadingCommercialInvoice(true);
    return getCommercialInvoice(shipmentValues, details)
      .then(res => {
        setCommercialInvoice(res.data);
        window.scrollTo(0, 0);
      })
      .finally(() => {
        setLoadingCommercialInvoice(false);
      });
  };

  return { handleGenerateCommercialInvoice, commercialInvoice, loadingCommercialInvoice };
};

export default useCommercialInvoice;
